import Link from 'next/link'

import { IconNotification, IconRight } from '../../General/Icon'

export type MypageSettingProps = {
  title: string
  urlPath: string
  hasNotificationBadge?: boolean
  textColor?: 'primary' | 'black'
  borderColor?: 'gray' | 'black'
  iconColor?: 'primary' | 'black'
}

const TEXT_COLOR_CLASS_LIST = {
  primary: 'text-primary',
  black: 'text-black',
}

const BORDER_COLOR_CLASS_LIST = {
  gray: 'border-ui-2',
  black: 'border-black',
}

const ICON_COLOR_CLASS_LIST = {
  primary: 'fill-primary',
  black: 'fill-black',
}

export const MypageSetting = ({
  title,
  urlPath,
  hasNotificationBadge,
  textColor = 'primary',
  borderColor = 'gray',
  iconColor = 'primary',
}: MypageSettingProps) => {
  return (
    <Link href={urlPath}>
      <a
        aria-label={`${title}に遷移する`}
        className={`flex justify-between items-center w-full max-w-full h-[52px] border-b ${BORDER_COLOR_CLASS_LIST[borderColor]} border-solid`}
      >
        <div className="flex items-end">
          <p
            className={`mr-4 text-sm font-bold ${TEXT_COLOR_CLASS_LIST[textColor]}`}
          >
            {title}
          </p>
          {hasNotificationBadge && <IconNotification />}
        </div>

        <IconRight className={`mr-16 ${ICON_COLOR_CLASS_LIST[iconColor]}`} />
      </a>
    </Link>
  )
}
